export function queryTokens(query) {
  return String(query || '')
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter(Boolean);
}

/** Composite key used to identify a child uniquely across items. */
export function childKey(itemId, childId) {
  return `${itemId}-${childId}`;
}

export function buildSearchIndex(sections) {
  const index = [];
  sections.forEach(section => {
    section.items.forEach(item => {
      const searchText = [item.title, item.description, item.helpQuery, ...(item.keywords || [])]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      index.push({
        type: 'item', sectionId: section.id, itemId: item.id, title: item.title,
        href: item.href, searchText,
      });
      (item.children || []).forEach(child => {
        const childSearchText = [child.title, child.description, ...(child.keywords || [])]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        index.push({
          type: 'child', sectionId: section.id, itemId: item.id, childId: child.id,
          title: child.title, href: child.href, searchText: childSearchText,
        });
      });
    });
  });
  return index;
}

export function searchNav(sections, query) {
  const tokens = queryTokens(query);
  if (!tokens.length) {
    return {
      matchingSectionIds: new Set(), matchingItemIds: new Set(), matchingChildIds: new Set(),
      itemIdsWithMatchingChildren: new Set(), resultCount: 0,
    };
  }

  const matchingSectionIds = new Set();
  const matchingItemIds = new Set();
  const matchingChildIds = new Set();
  const itemIdsWithMatchingChildren = new Set();
  let resultCount = 0;

  buildSearchIndex(sections).forEach(entry => {
    if (!tokens.every(token => entry.searchText.includes(token))) return;
    resultCount++;
    matchingSectionIds.add(entry.sectionId);
    matchingItemIds.add(entry.itemId);
    if (entry.childId) {
      matchingChildIds.add(childKey(entry.itemId, entry.childId));
      itemIdsWithMatchingChildren.add(entry.itemId);
    }
  });

  return {
    matchingSectionIds, matchingItemIds, matchingChildIds, itemIdsWithMatchingChildren, resultCount,
  };
}
